import React from "react";
import {
    FaBullseye,      // Overall Accuracy
    FaChartLine,     // RMSE
    FaBalanceScale,  // F1 Score
    FaBolt           // Profitable Bets / ROI
} from "react-icons/fa";


const DEFAULT_METRICS = [
    {
        icon: <FaBullseye />,
        value: "73.2%",
        label: "Overall Accuracy",
        note: "Match outcome predictions",
        delta: "+2.1%",
    },
    {
        icon: <FaChartLine />,
        value: "1.24",
        label: "Goal Prediction RMSE",
        note: "Expected goals accuracy",
        delta: "-0.08",
    },
    {
        icon: <FaBalanceScale />,
        value: "0.691",
        label: "F1 Score",
        note: "Balanced classification metric",
        delta: "+0.023",
    },
    {
        icon: <FaBolt />,
        value: "58.7%",
        label: "Profitable Bets",
        note: "ROI on betting markets",
        delta: "+4.2%",
    },
];


export default function ModelPerformance({
    title = "Model Performance",
    subtitle = "Our ensemble of machine learning models continuously learns from new data to improve prediction accuracy",
    metrics = DEFAULT_METRICS,
}) {
    return (
        <section className="mpx" style={{ overflowX: 'clip' }}>
            <div className="mpx__wrap">
                <header className="mpx__header">
                    <h2 className="mpx__title">{title}</h2>
                    <p className="mpx__subtitle">{subtitle}</p>
                </header>

                <div className="mpx__grid">
                    {metrics.map((m, i) => {
                        const neg = m.delta?.trim().startsWith("-");
                        return (
                            <article className="mpx__card" key={i} style={{ animationDelay: `${0.06 + i * 0.12}s` }}>
                                <div className="mpx__top">
                                    <div className="mpx__icon">{m.icon}</div>
                                    {m.delta && (
                                        <span className={`mpx__delta ${neg ? "mpx__delta--neg" : "mpx__delta--pos"}`}>
                                            {m.delta}
                                        </span>
                                    )}
                                </div>

                                <div className="mpx__value">{m.value}</div>
                                <div className="mpx__label">{m.label}</div>
                                <div className="mpx__note">{m.note}</div>

                                <div className="mpx__shine" aria-hidden />
                            </article>
                        );
                    })}
                </div>
                <div className="mpx__footer text-center">
                    <p style={{ paddingTop: '40px' }}>
                        By combining statistical rigor with advanced AI techniques, Predixio ensures that every prediction reflects the latest form, player performance, and external factors with unmatched precision.
                        This ongoing evolution gives users a decisive edge in making smarter, data-driven football decisions.
                    </p>
                </div>
            </div>
        </section>
    );
}
